import { render, staticRenderFns } from "./ProjectDropdown.vue?vue&type=template&id=10ce4fd7&scoped=true"
import script from "./ProjectDropdown.vue?vue&type=script&lang=js"
export * from "./ProjectDropdown.vue?vue&type=script&lang=js"
import style0 from "./ProjectDropdown.vue?vue&type=style&index=0&id=10ce4fd7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ce4fd7",
  null
  
)

export default component.exports